import React, { useEffect, useState } from "react";
import { getPersonalFaqByOrgUserId } from "../../../api/FAQ/Admin/PersonalFAQ/getPersonalFaqByOrgUserId";
import { getOrgUserPersonalFaqByOrgUserId } from "../../../api/FAQ/PersonalFq/getPersonalQueries";
import { useAuthContext } from "../../../hooks";
import AdminPersonalQueriesSc from "./index.sc";
import { useNavigate, useParams } from "react-router-dom";
function Index() {
  const auth = useAuthContext();
  const params = useParams();
  const navigate = useNavigate();
  const [personallFaq, setPersonalFaq] = useState<any>([]);
  const fetchOrgGenralFaq = async () => {
    await getPersonalFaqByOrgUserId(auth?.userInfo?.orgs[0]?.id, params?.userId)
      .then((e) => {
        console.log(e);
        setPersonalFaq(e);
      })
      .catch((e) => console.log(e));
  };
  //   const [personalFaq, setPersonalFaq] = useState<any>([]);
  //   const fetchOrgUserPersonallFaq = async () => {
  //     await getOrgUserPersonalFaqByOrgUserId(
  //       auth?.userInfo?.orgs[0]?.id,
  //       auth?.userInfo?.orgs_user_id[0].toString()
  //     )
  //       .then((e) => {
  //         console.log(e);
  //         setPersonalFaq(e);
  //       })
  //       .catch((e) => console.log(e));
  //   };
  useEffect(() => {
    fetchOrgGenralFaq();
    // fetchOrgUserPersonallFaq();
  }, []);
  console.log(params);
  return (
    <AdminPersonalQueriesSc>
      <div className="heading-container">
        <h3>Personal Faq`s</h3>
      </div>
      <div>
        <table>
          <tr>
            <th className="heading">S.no</th>
            <th className="heading">quest</th>
            <th className="heading">Name</th>

            <th className="heading">Applied Date</th>
          </tr>
          {personallFaq.length > 0 ? (
            personallFaq?.map((data: any, idx: any) => {
              return (
                <>
                  <tr onClick={() => navigate(`reply/${data?.pq_id}`)}>
                    <td>{idx + 1}</td>

                    <td>{data?.query}</td>
                    <td>{data?.posted_by}</td>
                    <td>{data?.created_at}</td>
                  </tr>
                </>
              );
            })
          ) : (
            <div>No Complaints from the Employee</div>
          )}
        </table>
      </div>
    </AdminPersonalQueriesSc>
  );
}

export default Index;
